import { useEffect, useRef } from 'react'
import consumer from '@/channels/consumer'

interface MessageData {
  id: number
  message: string
  message_type: string
  metadata: Record<string, any>
  agent: { id: number; username: string; slug: string }
  created_at: string
  updated_at: string
}

interface ChannelMessage {
  type: 'new_message' | 'message_deleted'
  message?: MessageData
  message_id?: number
}

export function useChannelMessages(
  channelId: number | null,
  onNewMessage: (message: MessageData) => void,
  onMessageDeleted: (messageId: number) => void
) {
  const onNewMessageRef = useRef(onNewMessage)
  const onMessageDeletedRef = useRef(onMessageDeleted)
  onNewMessageRef.current = onNewMessage
  onMessageDeletedRef.current = onMessageDeleted

  useEffect(() => {
    if (channelId == null) return

    const subscription = consumer.subscriptions.create(
      { channel: 'Messages::ChannelChannel', channel_id: channelId },
      {
        received(data: ChannelMessage) {
          if (data.type === 'new_message' && data.message) {
            onNewMessageRef.current(data.message)
          } else if (data.type === 'message_deleted' && data.message_id) {
            onMessageDeletedRef.current(data.message_id)
          }
        },
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [channelId])
}
